import React from 'react';
import { ArrowForward, ArrowBack } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { tokens } from '../theme';

const ArrowDirectionIcon = ({ direction, round, draft_position, teamCount, location = 'draft-cell', color }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const iconStyle = {
    fontSize: '11px',
    color: color || (location === 'round-header' ? colors.grey[200] : colors.grey[700]),
  };

  // If direction is provided directly, use it
  if (direction) {
    return direction === 'left' ? (
      <ArrowBack sx={iconStyle} />
    ) : (
      <ArrowForward sx={iconStyle} />
    );
  }

  // Calculate direction based on round and position
  if (round && draft_position && teamCount) {
    const isEvenRound = round % 2 === 0;
    const isLastPickInRound = draft_position === teamCount;
    
    if (isLastPickInRound) {
      // Show down arrow for last pick of the round
      return <ArrowForward sx={{ ...iconStyle, transform: 'rotate(90deg)' }} />;
    } else if (isEvenRound) {
      // Even rounds go right to left (snake back)
      return <ArrowBack sx={iconStyle} />;
    } else {
      // Odd rounds go left to right
      return <ArrowForward sx={iconStyle} />;
    }
  }

  // Default fallback
  return <ArrowForward sx={iconStyle} />;
};

export default ArrowDirectionIcon; 